module.exports = __webpack_public_path__ + "static/media/usuarios.8e76791e.png";